import { Box, Tooltip, TooltipProps, tooltipClasses, styled, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logoWhite from "./white_logo.png";
import { ENVIROMENT_NAME } from 'src/shared/environment';

function Logo() {
  const { t }: { t: any } = useTranslation();
  const theme = useTheme();
  return (
    <TooltipWrapper title={t('Bold Webclient by Dacsa')} arrow>
      <LogoWrapper to="/overview">
        <img src={logoWhite}></img><p style={{ "margin": "12px 0 0 10px", whiteSpace: 'nowrap', textTransform: 'capitalize', display: "block" }}>{ENVIROMENT_NAME}</p>
      </LogoWrapper>
    </TooltipWrapper>
  );
}

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        text-decoration: none;
        width: auto;
        margin: 0 auto;
        font-weight: ${theme.typography.fontWeightBold};
        & img{
          height: 45px;
          width:45px; 
        } 
`
);

const LogoSignWrapper = styled(Box)(
  () => `
        width: 42px;
        height: 28px;
`
);

const LogoSign = styled(Box)(
  ({ theme }) => `
        background: ${theme.general.reactFrameworkColor};
        width: 14px;
        height: 14px;
        border-radius: ${theme.general.borderRadiusSm};
        position: relative;
        transform: rotate(45deg);
        top: 2px;
        left: 10px;

        &:after, 
        &:before {
            content: "";
            display: block;
            width: 14px;
            height: 14px;
            position: absolute;
            top: -1px;
            right: -20px;
            transform: rotate(0deg);
            border-radius: ${theme.general.borderRadiusSm};
        }

        &:before {
            background: ${theme.palette.primary.main};
            right: auto;
            left: 0;
            top: 20px;
        }

        &:after {
            background: ${theme.palette.secondary.main};
        }
`
);

const LogoSignInner = styled(Box)(
  ({ theme }) => `
        width: 14px;
        height: 14px;
        position: absolute;
        top: 5px;
        left: 5px;
        z-index: 5;
        border-radius: ${theme.general.borderRadiusSm};
        background: ${theme.header.background};
`
);

const TooltipWrapper = styled(({ className, ...props }: TooltipProps) => (<Tooltip {...props} classes={{ popper: className }} />))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: { backgroundColor: theme.colors.alpha.trueWhite[100], color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]), fontSize: theme.typography.pxToRem(12), fontWeight: 'bold', borderRadius: theme.general.borderRadiusSm, boxShadow: '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)' },
  [`& .${tooltipClasses.arrow}`]: { color: theme.colors.alpha.trueWhite[100] }
}));

export default Logo;
